import Vue from 'vue'

const resource = 'activity_log'
const resource_name_plural = 'registros de actividad'

const methods = {
  POST: {title: 'Nuevo', variant: 'soft-success'},
  PUT: {title: 'Nuevo', variant: 'soft-success'},
  PATCH: {title: 'Actualización', variant: 'soft-primary'},
  DELETE: {title: 'Eliminado', variant: 'soft-danger'},
  ADD: {title: 'Agregar', variant: 'soft-success'},
  REMOVE: {title: 'Remover', variant: 'soft-warning'},
}

let state = {

}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource.map(el => {
          el._action = methods[el.action]
          return el
        }))
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
